/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { encodeBase64 } from "../../utils/utilityFunctions"
import { CALL_API } from "../middleware"
import {
    AssetAllocationGuidelineRes,
    GET_AMC_PERFORMANCE_ANALYSIS_DATA,
    GET_AMC_PERFORMANCE_ANALYSIS_DATA_SUCCESS,
    GET_ANALYTICS_HOLDINGS_DATA,
    GET_ANALYTICS_HOLDINGS_DATA_SUCCESS,
    GET_ASSET_ALLOCATION_GUIDELINE_DATA,
    GET_ASSET_ALLOCATION_GUIDELINE_DATA_SUCCESS,
    GET_BENCHMARK_PERFORMANCE_DATA,
    GET_BENCHMARK_PERFORMANCE_DATA_SUCCESS,
    GET_CUSTOMER_PORTFOLIOS_DATA,
    GET_CUSTOMER_PORTFOLIOS_DATA_SUCCESS,
    GET_HOLDING_PERIOD_ANALYSIS_DATA,
    GET_HOLDING_PERIOD_ANALYSIS_DATA_SUCCESS,
    GET_INVESTOR_ASSET_ALLOCATION_DATA,
    GET_INVESTOR_ASSET_ALLOCATION_DATA_SUCCESS,
    GET_MARKET_CAP_ALLOCATION_DATA,
    GET_MARKET_CAP_ALLOCATION_DATA_SUCCESS,
    GET_PORTFOLIO_HEALTH_DATA,
    GET_PORTFOLIO_HEALTH_DATA_SUCCESS,
    GET_PORTFOLIO_COMPLIANCE_DATA,
    GET_PORTFOLIO_COMPLIANCE_DATA_SUCCESS,
    GET_SCHEME_DETAILS_DATA,
    GET_SCHEME_DETAILS_DATA_SUCCESS,
    GET_TOTAL_VALUES_DATA,
    GET_TOTAL_VALUES_DATA_SUCCESS,
    GetAmcPerformanceAnalysisRequestBody,
    GetAmcPerformanceAnalysisResponseBody,
    GetAnalyticsHoldingsRequestBody,
    GetAnalyticsHoldingsResponseBody,
    GetAssetAllocationGuidelineBody,
    GetBenchmarkPerformanceRequestBody,
    GetBenchmarkPerformanceResponseBody,
    GetCustomerPortfoliosRequestBody,
    GetCustomerPortfoliosResponseBody,
    GetHoldingPeriodAnalysisRequestBody,
    GetHoldingPeriodAnalysisResponseBody,
    GetInvestorAssetAllocationRequestBody,
    GetInvestorAssetAllocationResponseBody,
    GetMarketCapAllocationRequestBody,
    GetMarketCapAllocationResponseBody,
    GetPortfolioHealthBody,
    GetPortfolioComplianceRequestBody,
    GetPortfolioComplianceResponseBody,
    GetSchemeDetailsRequestBody,
    GetSchemeDetailsResponseBody,
    GetTotalValuesRequestBody,
    GetTotalValuesResponseBody,
    PortfolioHealthResBody
} from "../types/analytics";

export const getCustomerPortfolios =
    (body: GetCustomerPortfoliosRequestBody) =>
        async (dispatch: any): Promise<GetCustomerPortfoliosResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/customerPortfolios`,
                    method: 'POST',
                    types: [GET_CUSTOMER_PORTFOLIOS_DATA_SUCCESS, GET_CUSTOMER_PORTFOLIOS_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };

export const getTotalValues =
    (body: GetTotalValuesRequestBody) =>
        async (dispatch: any): Promise<GetTotalValuesResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/totalValues`,
                    method: 'POST',
                    types: [GET_TOTAL_VALUES_DATA_SUCCESS, GET_TOTAL_VALUES_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };

export const getInvestorAssetAllocation =
    (body: GetInvestorAssetAllocationRequestBody) =>
        async (dispatch: any): Promise<GetInvestorAssetAllocationResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/getInvestorAssestAllocation`,
                    method: 'POST',
                    types: [GET_INVESTOR_ASSET_ALLOCATION_DATA_SUCCESS, GET_INVESTOR_ASSET_ALLOCATION_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };


export const getBenchmarkPerformance =
    (body: GetBenchmarkPerformanceRequestBody) =>
        async (dispatch: any): Promise<GetBenchmarkPerformanceResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/benchmarkPerformance`,
                    method: 'POST',
                    types: [GET_BENCHMARK_PERFORMANCE_DATA_SUCCESS, GET_BENCHMARK_PERFORMANCE_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };

export const getSchemeDetails =
    (body: GetSchemeDetailsRequestBody) =>
        async (dispatch: any): Promise<GetSchemeDetailsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/schemeDetails`,
                    method: 'POST',
                    types: [GET_SCHEME_DETAILS_DATA_SUCCESS, GET_SCHEME_DETAILS_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };

export const getAmcPerformanceAnalysis =
    (body: GetAmcPerformanceAnalysisRequestBody) =>
        async (dispatch: any): Promise<GetAmcPerformanceAnalysisResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/amcPerformanceAnalysis`,
                    method: 'POST',
                    types: [GET_AMC_PERFORMANCE_ANALYSIS_DATA_SUCCESS, GET_AMC_PERFORMANCE_ANALYSIS_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };

export const getAnalyticsHoldings =
    (body: GetAnalyticsHoldingsRequestBody) =>
        async (dispatch: any): Promise<GetAnalyticsHoldingsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/analyticsHoldings`,
                    method: 'POST',
                    types: [GET_ANALYTICS_HOLDINGS_DATA_SUCCESS, GET_ANALYTICS_HOLDINGS_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };

export const getHoldingPeriodAnalysis =
    (body: GetHoldingPeriodAnalysisRequestBody) =>
        async (dispatch: any): Promise<GetHoldingPeriodAnalysisResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/holdingPeriodAnalysis`,
                    method: 'POST',
                    types: [GET_HOLDING_PERIOD_ANALYSIS_DATA_SUCCESS, GET_HOLDING_PERIOD_ANALYSIS_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };

export const getMarketCapAllocation =
    (body: GetMarketCapAllocationRequestBody) =>
        async (dispatch: any): Promise<GetMarketCapAllocationResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/marketCapAllocation`,
                    method: 'POST',
                    types: [GET_MARKET_CAP_ALLOCATION_DATA_SUCCESS, GET_MARKET_CAP_ALLOCATION_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };


export const getAssetAllocationGuidelines =
    (body: GetAssetAllocationGuidelineBody) =>
        async (dispatch: any): Promise<AssetAllocationGuidelineRes> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/assetAllocationGuidelines`,
                    method: 'POST',
                    types: [GET_ASSET_ALLOCATION_GUIDELINE_DATA_SUCCESS, GET_ASSET_ALLOCATION_GUIDELINE_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };

export const getPortfolioHealth =
    (body: GetPortfolioHealthBody) =>
        async (dispatch: any): Promise<PortfolioHealthResBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/portfolioHealth`,
                    method: 'POST',
                    types: [GET_PORTFOLIO_HEALTH_DATA_SUCCESS, GET_PORTFOLIO_HEALTH_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    // body
                },
            });
        };

export const getPortfolioCompliance =
    (body: GetPortfolioComplianceRequestBody) =>
        async (dispatch: any): Promise<GetPortfolioComplianceResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: `/onboarding/dashboard/portfolioCompliance`,
                    method: 'POST',
                    types: [GET_PORTFOLIO_COMPLIANCE_DATA_SUCCESS, GET_PORTFOLIO_COMPLIANCE_DATA],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };
